<template>
    <div class="warpper">
        <div class="index-top ">
            <div v-if="userInfo" class="flex align-start header-card">
                <div class="avatar" @click="show = true">
                    <img v-if="user.orgData.morglogo" :src="user.orgData.morglogo" class="header-avatar"/>
                    <img v-else class="header-avatar" src="../../../../assets/img/avatar_member.jpg"/>
                </div>
                <div class="user-info flex-sub">
                    <router-link to="/mobile/memberChiose" class="rank-name active"
                                 v-if="list > 1">会员角色切换
                    </router-link>
                    <div class="flex align-center justify-between">
                        <h3>{{ userInfo.company }}</h3>
                        <div class="logout margin-left-xs" @click="show = true">退出登录</div>
                    </div>
                    <div class="rank-name">{{ userInfo.rank_name }}</div>
                    <div class="end-time flex align-center">
                        <span class="margin-right-xs">到期时间：{{ userInfo.end_time }}</span>
                        <i @click="toPay">立即续费</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="index-nav flex align-center justify-between flex-wrap">
            <router-link class="nav-item flex align-center " to="/mobile/member/notice">
                <img alt="" src="../../../../assets/img/mobile/index-icon1.png">通知公告
            </router-link>
            <router-link class="nav-item flex align-center " to="/mobile/member/active">
                <img alt="" src="../../../../assets/img/mobile/index-icon2.png">机构动态
            </router-link>
            <router-link class="nav-item flex align-center " to="/mobile/member/meeting">
                <img alt="" src="../../../../assets/img/mobile/index-icon3.png">活动管理
            </router-link>
            <router-link class="nav-item flex align-center " to="/mobile/member/service/list">
                <img alt="" src="../../../../assets/img/mobile/index-icon4.png">服务中心
            </router-link>
            <router-link class="nav-item flex align-center " to="/mobile/member/explain/list">
                <img alt="" src="../../../../assets/img/mobile/index-icon6.png">会员说明
            </router-link>

        </div>
        <div class="index-tab flex align-center justify-center">
            <span :class="{'active':tabType === 1}" @click="tabType = 1">通知公告</span>
            <span :class="{'active':tabType === 2}" @click="tabType = 2">机构动态</span>
        </div>

        <div class="list-box">
            <ul v-if="tabType === 1">
                <li v-for="(item,index) in notices" :key="index"
                    class="item-notice flex flex-direction justify-between" @click="toNoticeDetail(item.id)">
                    <div class="title ovHide">{{ item.title }}</div>
                    <div class="content ovHide">{{ item.content }}</div>
                    <div class="flex align-center">
                        <div :class="{ed:item.is_read ===1}" class="read">{{ item.is_read === 0 ? '未读' : '已读' }}</div>
                        <div :class="{yellow:item.is_feedback ===1}" class="time" v-if="item.feedback">
                            {{ item.is_feedback === 0 ? '未反馈' : '已反馈' }}
                        </div>
                        <div class="time">{{ item.add_time }}</div>
                    </div>
                </li>
            </ul>
            <ul v-if="tabType === 2">
                <li v-for="(item,index) in dynamics" :key="index" class="item-notice flex" @click="toActiveDetail(item.id)">
                    <el-image :src="item.thumb" class="image flex-shrink"></el-image>
                    <div class="flex flex-direction justify-between flex-sub margin-left-sm overflow-hidden">
                        <div class="title ovHide">{{ item.title }}</div>
                        <div class="content ovHide">
                            {{ item.content }}
                        </div>
                        <div class="time">{{ item.create_time }}</div>
                    </div>
                </li>
            </ul>
        </div>
        <van-action-sheet v-model="show" :actions="actions" cancel-text="取消"
                          close-on-click-action
                          @cancel="onCancel" @select="onSelect"/>

    </div>
</template>

<script>
import {getActives, getNotice, getOrganizInfo, userInfo} from "@/api/member";
import {zhDate} from "@/utils/utils";
import {reg_html} from "@/utils/rules";

export default {
    name: "index",
    data() {
        return {
            userInfo: null,
            orginizInfo: null,
            tabType: 1,
            notices: [],
            dynamics: [],
            show: false,
            actions: [{name: '退出登录'}],
            list: 1,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', 0)
        this.init()
        this.getOrganizInfo()
        this.getList()
        this.list = this.$store.state.userAll.length
    },
    components: {},
    methods: {
        onSelect(item) {
            this.show = false;
            if (item.name === '退出登录') {
                this.$confirm(
                    '您确定要退出吗？',
                    '温馨提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                    }
                ).then(() => {
                    this.$store.dispatch('LogOut').then(() => {
                        this.$router.replace('/login')
                        // location.reload() // 为了重新实例化vue-router对象 避免bug
                    })
                })
            }
        },
        onCancel() {
            this.show = false;
        },
        async init() {
            let _data = await userInfo()
            if (_data.status === 200) {
                _data.data.end_time = zhDate(_data.data.end_time * 1000)
                this.userInfo = _data.data
            }
        },
        async getOrganizInfo() {
            let _data = await getOrganizInfo()
            if (_data.status === 200) {
                this.orginizInfo = _data.data
            }

        },
        toPay() {
            this.$router.push('/mobile/member/payment')
        },
        //  页面加载时请求
        async getList() {
            let _notice = await getNotice()
            if (_notice.status === 200) {
                _notice.data.map(item => {
                    item.add_time = zhDate(item.add_time * 1000)
                    item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, '')
                })
                this.notices = _notice.data
            }
            let _dynamic = await getActives('', 1, 5)
            if (_dynamic.status === 200) {
                _dynamic.data.data.map(item => {
                    item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, '')
                })
                this.dynamics = _dynamic.data.data
            }
        },
        toNoticeDetail(id) {
            this.$router.push('/mobile/member/noticeDetail/' + id)
        },
        // 机构动态详情页
        toActiveDetail(id) {
            this.$router.push('/mobile/member/activeDetail/' + id)
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    .index-top {
        background: url(../../../../assets/img/mobile/blur-bg.png) #fff no-repeat top center;
        background-size: 100%;
        padding: 0 30px 30px;

        .header-card {
            position: relative;
            top: 60px;
            width: 100%;
            background-image: linear-gradient(0deg,
                #0d2a4e 0%,
                #0b3972 100%),
            linear-gradient(
                    #f3f7fb,
                    #f3f7fb);
            background-blend-mode: normal,
            normal;
            border-radius: 10px;
            padding: 30px;

            .avatar {
                width: 100px;
                height: 100px;
                border-radius: 100px;
                overflow: hidden;

                .header-avatar {
                    width: 100%;
                    object-fit: cover;
                }
            }

            .user-info {
                margin-left: 30px;

                h3 {
                    padding-top: 25px;
                    min-height: 85px;
                    line-height: 50px;
                    color: #fff;
                    margin-bottom: 15px;
                }

                .rank-name {
                    width: max-content;
                    height: 54px;
                    padding: 0 15px;
                    line-height: 52px;
                    border-radius: 10px;
                    text-align: center;
                    border: solid 1px #ff9600;
                    color: #ff9600;
                    font-size: 24px;
                    margin-bottom: 15px;
                }

                .end-time {
                    span {
                        font-size: 22px;
                        color: #fefefe;
                        opacity: 0.7;
                    }

                    i {
                        display: block;
                        width: 120px;
                        height: 48px;
                        background-image: linear-gradient(37deg,
                            #ffb400 0%,
                            #fc7802 100%),
                        linear-gradient(
                                #0a2240,
                                #0a2240);
                        background-blend-mode: normal,
                        normal;
                        border-radius: 24px;
                        text-align: center;
                        line-height: 48px;
                        color: #fff;
                        font-size: 22px;
                    }
                }

            }
        }
    }

    .index-nav {
        background: #fff;
        padding: 60px 30px 0;

        .nav-item {
            width: calc((100vw - 90px) / 2);
            height: 146px;
            background-color: #f3f7fb;
            border-radius: 10px;
            margin-bottom: 30px;
            font-size: 30px;
            padding-left: 45px;

            img {
                width: 36px;
                margin-right: 15px;
            }
        }
    }

    .index-tab {
        padding: 30px;

        span {
            display: block;
            margin: 0 30px;
            font-size: 28px;
            line-height: 60px;
            color: #999999;

            &.active {
                color: #333;
                position: relative;

                &:after {
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    content: '';
                    transform: translate(-50%, 0);
                    width: 27px;
                    height: 4px;
                    background-color: #ff9600;
                    border-radius: 2px;
                }
            }
        }
    }

    .list-box {
        padding: 0 30px;

        .item-notice {
            width: 100%;
            background-color: #fff;
            border-radius: 20px;
            margin-bottom: 30px;
            padding: 30px;
            cursor: pointer;
            position: relative;

            .tag {
                position: absolute;
                top: 0;
                right: 0;
            }

            &.active {
                .item-operate {
                    display: none;
                }

                &:hover {
                    position: relative;

                    .item-operate {
                        position: absolute;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: #00000033;

                        .to-apply {
                            width: 80px;
                            height: 80px;
                            line-height: 80px;
                            border-radius: 80px;
                            text-align: center;
                            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                            linear-gradient(#ff9600, #ff9600);
                            background-blend-mode: normal, normal;
                            color: #ffffff;
                            font-size: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .image {
                width: 140px;
                height: 110px;
                border-radius: 10px;
            }

            .image-container {
                width: 116px;
                height: 88px;
                border-radius: 10px;
                position: relative;

                .apply-total {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    background-color: #00000022;
                    font-size: 10px;
                    color: #ffffff;
                    border-radius: 0 0 10px 10px;
                }
            }

            .title {
                font-size: 26px;
                line-height: 32px;
                font-weight: bold;
                color: #0a2240;
                margin-bottom: 10px;
            }

            .classify {
                background-color: #ff9600;
                border-radius: 9px;
                padding: 3px 6px;
                font-size: 18px;
                color: #fefeff;
                margin-right: 6px;
            }

            .content {
                width: 100%;
                font-size: 24px;
                color: #7889a4;
                margin-bottom: 10px;
            }

            .read {
                padding: 0 15px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background-color: #ff9600;
                border-radius: 15px;
                font-size: 20px;
                color: #ffffff;
                margin-right: 15px;

                &.ed {
                    background-color: #8ba2c6;
                }
            }

            .time {
                font-size: 20px;
                color: #7889a4;
                line-height: 30px;
                margin-right: 15px;

                &.yellow {
                    color: #ff9600;
                }
            }
        }
    }

    .rank-name {
        &.active {
            position: absolute;
            top: -60px;
            right: 0;
            background: #ff9600;
            color: #fff !important;
        }
    }


    .logout {
        height: 45px;
        line-height: 45px;
        border-radius: 45px;
        padding: 0 20px;
        border: solid 1px #ffffff55;
        color: #FFFFFF;
        font-size: 18px;
    }
}
</style>
